import { render, staticRenderFns } from "./SideAside.vue?vue&type=template&id=1612076a"
import script from "./SideAside.vue?vue&type=script&lang=js"
export * from "./SideAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports